import { get, postj } from '@/utils/request';

export const list = (param) => get('address/index',param); // 订单列表
export const addressDel = (data) => postj('address/delete',data); // 删除
export const addressAdd = (data) => postj('address/create',data); // 新增
export const addressUpdate = (data) => postj('address/update',data); // 编辑
export const provinceList = (param) => get('address/province',param); // 省/州代码
export const zipCode = (param) => get('address/zipCode',param); // 根据邮编获取公用的地址信息